import { lazy } from 'react';

export const Calendar = lazy(() => import('./calendar'));
export const TeamWeek = lazy(() => import('./team-week'));
